import React from "react";
import classNames from "classnames";
import { RequestStatus } from "../../../../types/mydata";
import { Typography } from "../../../../components/__common/Typography/Typography";

interface StepsProps {
  status: RequestStatus;
}

export const Steps: React.FC<StepsProps> = (props) => {
  const { status } = props;
  const allowedStatuses = [
    RequestStatus.COMPLETED,
    RequestStatus.PROCESSING,
    RequestStatus.REQUESTING,
    RequestStatus.QUEUED,
    RequestStatus.FAILED,
  ];

  const stepOneValue = status === RequestStatus.FAILED ? 1 : "";

  const stepTwoValue = status === RequestStatus.PROCESSING ? 2 : "";
  const stepThreeValue = status === RequestStatus.COMPLETED ? 3 : "";

  return (
    <>
      {allowedStatuses.includes(status) && (
        <div className="request-details__steps">
          <Typography
            variant="body3"
            className={classNames("request-details__steps__step", {
              active: status === RequestStatus.FAILED,
              prev: status !== RequestStatus.FAILED,
            })}
          >
            {stepOneValue}
          </Typography>

          <Typography
            variant="body3"
            className={classNames("request-details__steps__step", {
              active: status === RequestStatus.PROCESSING,
              prev: status === RequestStatus.COMPLETED,
            })}
          >
            {stepTwoValue}
          </Typography>
          <Typography
            variant="body3"
            className={classNames("request-details__steps__step", {
              active: status === RequestStatus.COMPLETED,
            })}
          >
            {stepThreeValue}
          </Typography>
        </div>
      )}
    </>
  );
};
